<template>
  <el-dialog
    v-if="dialogVisible"
    :title="$t('delegatedOperationText')"
    :visible.sync="dialogVisible"
    width="900px"
    custom-class="delegated-operation-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <BjPage
      ref="BjPage"
      height="420px"
      :query-params="queryParams"
      :col-span="6"
      :search-btn-span="6"
      :get-action="queryCustomerList"
      :serial="true"
      :selection="false"
      :right-toolbar-hide="true"
      :before-reset-search="beforeResetSearch"
      @submit.native.prevent
    >
      <template v-slot:baseForm>
        <el-col :span="6">
          <el-form-item :label="$t('AccountManagement.customer.account')" prop="clientCode">
            <BjSelectLov
              v-model="queryParams.clientCode"
              :option-list="newClientCode"
              :placeholder="$t('AccountManagement.customer.account')"
              @change="value => handleSelectQuery('clientCode', value)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('AccountManagement.customer.name')" prop="cusId">
            <BjSelectLov
              v-model="queryParams.cusId"
              :option-list="customerList"
              :placeholder="$t('customerNameText')"
              @change="value => handleSelectQuery('cusId', value)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('workOrderList.Customer')" prop="csgCustomer">
            <BjSelectLov
              v-model="queryParams.csgCustomer"
              :option-list="customerNameList"
              :placeholder="$t('workOrderList.Customer')"
              @change="value => handleSelectQuery('csgCustomer', value)"
            />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <el-table-column :label="$t('customerNameText')" prop="cusName" align="center" width="160" />
        <el-table-column :label="$t('clientCodeText')" prop="clientCode" align="center" width="160" />
        <el-table-column :label="$t('workOrderList.Customer')" prop="csgCustomer" align="center" width="160" />
        <el-table-column :label="$t('table.statusText')" prop="enabled" align="center" width="160">
          <template v-slot="{ row }">
            {{ row.enabled === false ? $t('disableText') : $t('enableText') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.operationText')" align="center" width="160" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              :disabled="row.enabled === false"
              :loading="delegatingId === getRowKey(row)"
              @click="handleDelegate(row)"
            >
              {{ $t('delegateOnceText') }}
            </el-button>
          </template>
        </el-table-column>
      </template>
    </BjPage>

  </el-dialog>
</template>

<script>
import { commonApi, userApi } from '@/api';
import ElTableColumn from '@/components/ElTableColumn';
import { getToken, setAdminToken, setImpersonationInfo, setToken } from '@/utils/auth';

export default {
  name: 'DelegatedOperationDialog',
  components: {
    ElTableColumn,
  },
  data() {
    return {
      dialogVisible: false,
      delegatingId: null,
      customerNameList: [],
      queryParams: {
        customerType: 'C',
        clientCode: null,
        cusId: null,
        csgCustomer: null,
      },
    };
  },
  computed: {
    customerList() {
      return this.$store.getters.customerList;
    },
    clientCodeList() {
      return this.$store.getters.clientCodeList;
    },
    newClientCode() {
      return this.clientCodeList.map(item => {
        return {
          label: item.clientCode,
          value: item.clientCode,
        };
      });
    },
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.getCustomerServiceList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    beforeResetSearch() {
      this.queryParams.customerType = 'C';
      this.queryParams.clientCode = null;
      this.queryParams.cusId = null;
      this.queryParams.csgCustomer = null;
      return Promise.resolve();
    },
    queryCustomerList(params) {
      return userApi.getUserList({
        ...params,
        customerType: 'C',
      });
    },
    handleQuery() {
      this.$refs.BjPage && this.$refs.BjPage.onSearch();
    },
    handleSelectQuery(key, value) {
      this.$set(this.queryParams, key, value);
      this.$nextTick(() => {
        this.handleQuery();
      });
    },
    getCustomerServiceList() {
      if (this.customerNameList.length) return;
      userApi.getUserList({
        enabled: true,
        customerType: 'P',
        deptAbbr: 'Customer Service',
      }).then(res => {
        if (res.content && res.content.length) {
          this.customerNameList = res.content.map(item => {
            return {
              label: item.realName,
              value: item.realName,
            };
          });
        }
      });
    },
    getRowKey(row) {
      return row.userId || row.id || row.cusId;
    },
    handleDelegate(row) {
      if (row.enabled === false) return;
      this.$confirm(
        this.$t('confirmDelegateOperationText', {
          customerName: row.cusName || '-',
          clientCode: row.clientCode || '-',
        }),
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
          customClass: 'delegated-operation-confirm',
        },
      ).then(() => {
        const targetUserId = this.getRowKey(row);
        this.delegatingId = targetUserId;
        commonApi.createAdminImpersonation({
          targetUserId,
          reason: '代客操作',
        }).then(res => {
          console.log(res);
          const accessToken = res && res.access_token;
          if (!accessToken) return;

          const currentToken = getToken();
          if (currentToken) {
            setAdminToken(currentToken);
          }

          setImpersonationInfo({
            targetUserId,
            accessToken,
            tokenType: res.token_type,
            expiresIn: res.expires_in,
            impersonationSessionId: res.impersonation_session_id,
            subjectUserId: res.subject_user_id,
            scope: res.scope,
            startedAt: Date.now(),
          });
          setToken(accessToken);
          this.$store.dispatch('user/setToken', accessToken);
          sessionStorage.clear();
          this.$store.dispatch('tagsView/delAllViews').finally(() => {
            location.href = location.href.replace(location.hash, '');
          });
        }).finally(() => {
          this.delegatingId = null;
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.delegated-operation-confirm {
  width: 520px;

  .el-message-box__message {
    word-break: normal;
    overflow-wrap: break-word;
  }
}
</style>
